"use client";

import type { MouseEvent } from "react";

type SkipToContentLinkProps = {
  className: string;
};

const findMainContentTarget = (): HTMLElement | null => {
  const directTarget = document.getElementById("main-content");
  if (directTarget instanceof HTMLElement) {
    return directTarget;
  }

  const fallbackTarget = document.querySelector("main, [role='main']");
  return fallbackTarget instanceof HTMLElement ? fallbackTarget : null;
};

const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
  const target = findMainContentTarget();
  if (!target) {
    return;
  }

  event.preventDefault();

  if (!target.hasAttribute("tabindex")) {
    target.setAttribute("tabindex", "-1");
  }

  target.focus({ preventScroll: true });
  target.scrollIntoView({ block: "start" });
};

export function SkipToContentLink({ className }: SkipToContentLinkProps) {
  return (
    // biome-ignore lint/a11y/useValidAnchor: Native anchor navigation keeps the skip link working before hydration.
    <a className={className} href="#main-content" onClick={handleClick}>
      Skip to content
    </a>
  );
}
